import * as api from "api/endpoints/analytics";
import { createSlice, createSliceSelector } from "../../factory";

const name = "overviewOnboardingPage";

const initialState = {
  verifiedApplicationData: [],
  verifiedApplicationUrl: null,
  verifiedApplicationLoading: false
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectVerifiedApplication = createSelector((state) => {
  return {
    data: state.verifiedApplicationData,
    url: state.verifiedApplicationUrl,
    loading: state.verifiedApplicationLoading
  };
});

/* Actions */
const { update } = slice.actions;

export function loadOnboardingData(start, end, epId) {
  const config = { params: { start, end, type: "Verified Applications", epId } };

  return async function (dispatch) {
    dispatch(update({ verifiedApplicationLoading: true }));

    const appData = await api.getApplications(config);
    const reportsData = await api.getApplicationReports(config);

    const payload = {
      verifiedApplicationData: appData.details,
      verifiedApplicationUrl: reportsData.epFileURL,
      verifiedApplicationLoading: false
    };

    dispatch(update(payload));
  };
}
